<template>
<div class="help" v-loading="loading">
  <div class="sec">
    <top :title="'帮助中心'"></top>
    <div class="con" v-html="temp"></div>
  </div>
</div>

</template>

<script>
import top from '@/components/common/top/top'
import { configResource } from '@/resource/resource'

const ERR_OK = 0

export default {
  name: 'help',
  data () {
    return {
      loading: false,
      temp: null
    }
  },
  created() {
    this.getHelp()
  },
  methods: {
    getHelp() {
      configResource.config({ config: 'site_help' }).then(response => {
        response = response.body
        this.loading = false
        if (response.errcode === ERR_OK) {
          this.temp = response.data.site_help
        }
      })
    }
  },
  components: {
    top
  }
}
</script>

<style lang="stylus" scoped>
.help
  width 1000px
  margin 0 auto
  .sec
    .con
      padding 25px 40px
      color #626262
      font-size 14px
      border 1px solid #dcdcdc
      line-height 22px
</style>



// WEBPACK FOOTER //
// help.vue?2ef70539